import { configureStore } from '@reduxjs/toolkit';
import portfolioReducer from './slices/portfolioSlice';
import userReducer from './slices/userSlice';
import authReducer from './slices/authSlice';
import publicReducer from './slices/publicSlice';

const store = configureStore({
  reducer: {
    portfolio: portfolioReducer,
    user: userReducer,
    auth: authReducer,
    public: publicReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these specific action types
        ignoredActions: [
          'portfolio/fetch/fulfilled',
          'portfolio/analyze/fulfilled',
          'portfolio/compare/fulfilled',
          'user/fetchCurrent/fulfilled'
        ],
        // Ignore these paths in the state
        ignoredPaths: [
          'portfolio.data.headers',
          'portfolio.analysis.headers',
          'user.data.headers',
          'auth.token'  // For auth token
        ],
        // Ignore these field paths in actions
        ignoredActionPaths: [
          'meta.arg',
          'payload.headers',
          'payload.config',
          'payload.request',
          'payload.token'
        ]
      },
    }),
});

export default store;